
    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    module.exports = {
  "contentWidthDefault": "1280px",
  "contentWidthText": "768px",
  "contentWidthFull": "100%",
  "spacing2Xs": "0.25rem",
  "spacingXs": "0.5rem",
  "spacingS": "0.75rem",
  "spacingM": "1rem",
  "spacingL": "1.5rem",
  "spacingXl": "2rem",
  "spacing2Xl": "3rem",
  "spacing3Xl": "4rem",
  "spacing4Xl": "5rem",
  "zIndexNegative": "-1",
  "zIndexWorkbench": "0",
  "zIndexDefault": "1",
  "zIndexWorkbenchHeader": "10",
  "zIndexModal": "100",
  "zIndexModalContent": "101",
  "zIndexDropdown": "1000",
  "zIndexTooltip": "10000",
  "zIndexNotification": "100000",
  "boxShadowDefault": "0 1px 3px rgba(0, 0, 0, 0.08)",
  "boxShadowHeavy": "0 2px 3px rgba(0, 0, 0, 0.35)",
  "glowPrimary": "0px 0px 7px #3c80cf",
  "glowNegative": "0px 0px 7px #d9453f",
  "glowPositive": "0px 0px 7px #0eb87f",
  "glowWarning": "0px 0px 7px #ea9005",
  "colorBlueDark": "#3072be",
  "colorBlueBase": "#3c80cf",
  "colorBlueMid": "#4a90e2",
  "colorBlueLight": "#5b9fef",
  "colorContrastDark": "#0c141c",
  "colorContrastMid": "#192532",
  "colorContrastLight": "#263545",
  "colorCoralDark": "#d0a2a0",
  "colorCoralMid": "#fbe3e2",
  "colorElementDarkest": "#b4c3ca",
  "colorElementDark": "#c3cfd5",
  "colorElementMid": "#d3dce0",
  "colorElementLight": "#e5ebed",
  "colorElementLightest": "#f7f9fa",
  "colorGreenDark": "#0baa75",
  "colorGreenBase": "#0eb87f",
  "colorGreenMid": "#19cd91",
  "colorGreenLight": "#14d997",
  "colorIceDark": "#c5d2d8",
  "colorIceMid": "#e8f7ff",
  "colorMintDark": "#b7ded0",
  "colorMintMid": "#f4fffb",
  "colorOrangeDark": "#db8500",
  "colorOrangeBase": "#ea9005",
  "colorOrangeMid": "#fba012",
  "colorOrangeLight": "#ffb239",
  "colorPeachDark": "#d2ac79",
  "colorPeachMid": "#ffe9cc",
  "colorRedDark": "#cd3f39",
  "colorRedBase": "#d9453f",
  "colorRedMid": "#e34e48",
  "colorRedLight": "#f05751",
  "colorPrimary": "#3c80cf",
  "colorPositive": "#0eb87f",
  "colorNegative": "#d9453f",
  "colorWarning": "#ea9005",
  "colorTextDark": "#2a3039",
  "colorTextMid": "#536171",
  "colorTextLight": "#8091a5",
  "colorTextLightest": "#a9b9c0",
  "colorWhite": "#ffffff",
  "transitionDurationShort": "0.1s",
  "transitionDurationDefault": "0.2s",
  "transitionDurationLong": "0.3s",
  "transitionEasingDefault": "ease-in-out",
  "transitionEasingCubicBezier": "cubic-bezier(0.13, 0.62, 0.11, 0.99)",
  "fontBaseDefault": "16",
  "fontSize3Xl": "2.1875rem",
  "fontSize2Xl": "1.75rem",
  "fontSizeXl": "1.3125rem",
  "fontSizeL": "1rem",
  "fontSizeM": "0.875rem",
  "fontSizeS": "0.75rem",
  "fontStackPrimary": "-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",
  "fontStackMonospace": "SFMono-Regular, Consolas, Liberation Mono, Menlo,monospace",
  "fontWeightNormal": "400",
  "fontWeightMedium": "600",
  "fontWeightDemiBold": "700",
  "letterSpacingWide": "0.1rem",
  "lineHeightDefault": "1.5",
  "lineHeightCondensed": "1.25"
}
    